import React from 'react';
import logo from 'image/logo/logo_01.png';
import {Empty} from 'components/items';

const BoardDetailComments = (props) => {
  return (
    <section className="BoardDetailComments">
        {props.comment
        ? props.comment.map((el,index) => {
          return  <div className="wrap-comment" key = {index}>
                    <div className="wrap-img">
                      <img className="comment-logo" src={logo} alt="logo"/>
                    </div>

                    <div className="wrap-text">
                      <p className="comment">{el.text}</p>
                      <div className="wrap-caption">
                        <p className="comment-name">동구밭</p>
                        <p className = "comment-date">{el.date}</p>
                      </div>
                    </div>
                  </div>
        })
        : <div className="wrap-comment">
            <div className="wrap-text">
              <Empty text = "아직 답변이 없습니다. " />
            </div>
          </div>}
        

    </section>
  );
}

export default BoardDetailComments;